// The component types the Playground can add and edit: the chalk elements
// they can present (the first is the default), and the configurable fields
// of their create_agent_v1 config classes as per-field JSON schemas
// (identity, channels, and token category are the Playground's own
// concern).
export type SupportedComponent = {
  type: string;
  elements: Array<string>;
  fields: Record<string, Record<string, unknown>>;
};

export const SUPPORTED_COMPONENTS: Array<SupportedComponent> = [
  {
    type: "limited_list",
    elements: ["items", "itemized"],
    fields: {
      max_entries: {
        title: "Max Entries",
        type: "integer",
        minimum: 1,
        default: 1000,
      },
      description: { title: "Description", type: "string" },
      accept_generation: {
        title: "Accept Generation",
        type: "boolean",
        default: true,
      },
    },
  },
  {
    type: "kv_store",
    elements: ["data"],
    fields: {
      delimiter: { title: "Delimiter", type: "string" },
      description: { title: "Description", type: "string" },
      indent: { title: "Indent", type: "string", default: "  " },
    },
  },
];

export const supportedComponent = (
  type: string | undefined
): SupportedComponent | undefined =>
  SUPPORTED_COMPONENTS.find((supported) => supported.type === type);
